import { render, staticRenderFns } from "./addaturtle.vue?vue&type=template&id=47c2cdd8&scoped=true&"
import script from "./addaturtle.vue?vue&type=script&lang=js&"
export * from "./addaturtle.vue?vue&type=script&lang=js&"
import style0 from "./addaturtle.vue?vue&type=style&index=0&id=47c2cdd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2cdd8",
  null
  
)

export default component.exports